export const CitiesColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Город',
        key: 'nameRu',
    },
    {
        name: 'Перевод (KZ)',
        key: 'nameKz',
    },
    {
        name: 'Перевод (EN)',
        key: 'nameEn',
    },
    {
        name: 'Область/регион',
        key: 'region',
    },
    {
        name: 'Перевод (ZH)',
        key: 'nameZh',
    },
    {
        name: 'Дата создания',
        key: 'createdAt',
    },
    {
        name: 'Почтовый индекс',
        key: 'postCode',
    },
    {
        name: 'Статус',
        key: 'status',
    },
    {
        name: 'Центр города',
        key: 'center',
    },
    {
        name: 'Границы',
        key: 'borders',
    },
]

export const RegionsColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Регион',
        key: 'name',
    },
    {
        name: 'Страна',
        key: 'country',
    },
]
